<script setup lang="ts">
// types
import type { BlockStatsItemProps } from '@ts-blocks/block-stats-item/interfaces'

defineOptions({
  name: 'BlockStatsItem',
})

defineProps<{
  block: BlockStatsItemProps
}>()
</script>

<template>
  <div class="block-stats-item">
    <p class="block-stats-item__number btly-text-title-l lg:btly-text-title-xl">
      {{ block.number }}
    </p>
    <p class="block-stats-item__label btly-text-body-m lg:btly-text-body-l">
      {{ block.label }}
    </p>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockStatsItem.scss" />
